import { formatMoney } from './format'

/**
 * @param {import('./types').InsightRecord} insight
 * @returns {import('./types').RecommendationCardDraft[]}
 */
export function buildSalesPaceCards(insight) {
  const metadata =
    typeof insight.metadata === 'string'
      ? JSON.parse(insight.metadata || '{}')
      : insight.metadata || {}

  const impact = Number(insight.impact_amount || 0)
  const confidence = Number(insight.confidence_score || 0)
  const pctDiff = Math.abs(Number(metadata.pctDiff || 0))
  const priority = insight.severity || 'medium'

  return [
    {
      category: 'promotion',
      priority,
      title: 'Run a Targeted Promotion',
      subtitle:
        insight.summary ||
        'Comparable events sold faster at this point in the sales cycle.',
      expectedRevenueLift: impact * 0.4,
      confidenceScore: confidence,
      primaryMetric: {
        label: 'Expected Lift',
        value: formatMoney(impact * 0.4, { signed: true }),
      },
      secondaryMetric: {
        label: 'Sell-through gap',
        value: `-${pctDiff.toFixed(0)}%`,
      },
      suggestedActions: [
        {
          type: 'run_promotion',
          label: 'Create promotion',
          actionPayload: { actionType: 'run_promotion' },
        },
      ],
      ctaLabel: 'Create Promotion',
      actionPayload: { actionType: 'run_promotion' },
      displayOrder: 1,
    },
    {
      category: 'pricing',
      priority: 'medium',
      title: 'Review Remaining Inventory Pricing',
      subtitle:
        'Adjust pricing on high-inventory sections to close the sell-through gap.',
      expectedRevenueLift: impact * 0.35,
      confidenceScore: Math.max(confidence - 5, 50),
      primaryMetric: {
        label: 'Expected Lift',
        value: formatMoney(impact * 0.35, { signed: true }),
      },
      secondaryMetric: {
        label: 'Benchmark gap',
        value: `${pctDiff.toFixed(0)}% behind`,
      },
      suggestedActions: [
        {
          type: 'review_pricing',
          label: 'Review pricing',
          actionPayload: { actionType: 'review_pricing' },
        },
      ],
      ctaLabel: 'Review Pricing',
      actionPayload: { actionType: 'review_pricing' },
      displayOrder: 2,
    },
    {
      category: 'marketing',
      priority: 'medium',
      title: 'Email Waitlist and Past Buyers',
      subtitle:
        'Re-engage buyers who showed interest or purchased similar events.',
      expectedRevenueLift: impact * 0.25,
      confidenceScore: Math.max(confidence - 8, 45),
      primaryMetric: {
        label: 'Expected Lift',
        value: formatMoney(impact * 0.25, { signed: true }),
      },
      secondaryMetric: {
        label: 'Audience',
        value: 'Waitlist + past buyers',
      },
      suggestedActions: [
        {
          type: 'email_waitlist',
          label: 'Send campaign',
          actionPayload: { actionType: 'email_waitlist' },
        },
      ],
      ctaLabel: 'Build Campaign',
      actionPayload: { actionType: 'email_waitlist' },
      displayOrder: 3,
    },
  ]
}
